export const URL = {
  数据中心: '/admin/dataCenter',
  图文资讯: '/admin/industryIdynamics',
  联盟管理: '/admin/allianceManagement',
  联盟活动: '/admin/allianceActivities',
  成员管理: '/admin/userCenter',
  产品管理: '/admin/productManagement',
  公共模块管理: '/admin/commonModule',
  单元测试实验室: '/admin/testModule'
}
export default {
  URL
};



// WEBPACK FOOTER //
// ./src/config/index.js